module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("1.")]), _vm._v(" Young officer and servant set out to join his regiment, from Rowlandson’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Johnny Newcome")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("2.")]), _vm._v(" On the march in the rains, by St Clair.")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("3.")]), _vm._v(" Muleteers near Irun, by Batty.")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("4.")]), _vm._v(" Light dragoon outpost, by William Wollen.")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("5.")]), _vm._v(" A young officer learns how to smoke and drink, from Rowlandson’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Johnny Newcome")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("6.")]), _vm._v(" Soldiers on the march, by Thomas Rowlandson.")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("7.")]), _vm._v(" 10th Hussars in camp at Morales, by Denis Dighton.")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("8.")]), _vm._v(" Cavalry stabling in a church.")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu1"
  }, [_vm._v("9.")]), _vm._v(" Bivouac at Vilha Velha 1811, by St Clair.")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("10.")]), _vm._v(" Spanish camp in the Pyrenees, by Batty.")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("11.")]), _vm._v(" Officer on the Sick List, from Rowlandson’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Johnny Newcome")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("12.")]), _vm._v(" The troops advance – note the soldier stripping the dead in the foreground – from Rowlandson’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Johnny Newcome")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("13.")]), _vm._v(" Battle of Albuera, by William Wollen.")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("14.")]), _vm._v(" Marching the French prisoners into Salamanca, by Edward Orme.")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("15.")]), _vm._v(" Storming a fortress.")])]), _vm._v(" "), _c('p', {
    staticClass: "illuj"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Plates#illu16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu"
  }, [_vm._v("16.")]), _vm._v(" Collecting the dead after Talavera, by Lady Butler.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e00aa834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Illustrations.vue
// module id = 69
// module chunks = 0